import {NgIf} from '@angular/common';
import {Component, Input, inject} from '@angular/core';
import {TranslocoModule} from '@ngneat/transloco';
import {environment} from '../../../../../environments/environment';
import {IubendaService} from '../../../../services/iubenda.service';

@Component({
    selector: 'marketplace-footer',
    standalone: true,
    imports: [NgIf, TranslocoModule],
    templateUrl: './marketplace-footer.component.html',
    styleUrl: './marketplace-footer.component.css',
})
export class MarketplaceFooterComponent {
    #iubendaService = inject(IubendaService);

    @Input() title = 'Be Our Best';
    @Input() showStoreBadges = true;
    @Input() showCookiePreferences = true;

    storeUrl = environment.storeUrl;
    iubenda = environment.iubenda;

    iubendaIsAvailable(): boolean {
        return this.#iubendaService.isAvailable();
    }

    openIubendaPref(event: MouseEvent): void {
        event.preventDefault();
        this.#iubendaService.openPreferences();
    }
}
